"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSettingRepository = void 0;
const httpRepository_1 = __importDefault(require("./httpRepository"));
exports.UserSettingRepository = {
    getUserSettings: async (settingName) => {
        const response = await httpRepository_1.default.tradeshiftGo().get(`/rest/userSettings/${settingName}`);
        return response.data;
    },
    saveUserSetting: async (settingsValues) => {
        const response = await httpRepository_1.default.tradeshiftGo().post('/rest/userSettings/save', settingsValues);
        return response.data;
    },
};
